/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { priceFormat } from '../../helper';
import LineItem from './line-item';

class Shipment extends Component {
    _isShipped() {
        return this.props.shipment.state === 'shipped';
    }

    _shipmentStateMarkup() {
        const thisShipment = this.props.shipment;

        if (this._isShipped()) {
            return (
                <div>
                    <FormattedMessage id="shipmentState.shipped" defaultMessage="Shipped" />
                    {thisShipment.attributes.shipped_at}
                </div>
            );
        }

        if (thisShipment.attributes.state === 'pending') {
            return <FormattedMessage id="shipmentState.pending" defaultMessage="Shipment under Review" />;
        }
        if (thisShipment.attributes.state === 'ready') {
            return <FormattedMessage id="shipmentState.ready" defaultMessage="Dispatching soon" />;
        }
        if (thisShipment.attributes.state === 'canceled') {
            return <FormattedMessage id="shipmentState.canceled" defaultMessage="Shipment Canceled" />;
        }
    }

    _shipmentLineItemsMarkup(storeId, shipment) {
        const filteredList = this.props.order.line_items.filter((item) => item.attributes && item.attributes.inventory_unit && item.attributes.inventory_unit.shipment_id === Number(shipment.id));
        let total = 0;
        return filteredList && filteredList.length > 0 && filteredList
            .map((lineItem, idx) => {
                total += lineItem.variant.attributes.price * lineItem.attributes.quantity;
                return <LineItem lineItem={lineItem} key={idx} />;
            })
            .concat(
                <LineItem
                    customContent
                    col2={<FormattedMessage id="shippingCharges" defaultMessage="Shipping Charges" />}
                    col3={shipment.selected_shipping_rate.attributes.display_cost}
                    key={filteredList.length + 1}
                />,
                <LineItem
                    customContent
                    col2={<FormattedMessage id="orderTotal" defaultMessage="Order Total" />}
                    col3={priceFormat.format(total + parseFloat(shipment.selected_shipping_rate.attributes.cost, 10))}
                    key={filteredList.length + 2}
                    noBottomBorder
                />,
            );
    }

    render() {
        const {
            shipment: thisShipment,
            store,
            excludeShipmentNumber,
            style,
            hideStoreName = false,
            details,
            ...others
        } = this.props;

        return (
            <div className="shipment-view" {...others}>
                <div className="row order-padding" style={style}>
                    <div className="col-sm-12 margin-top-30">
                        <div className="shipment-header order-block-header no-margin">
                            <h3 style={{ display: hideStoreName ? 'none' : 'initial' }}>{store && store.name}</h3>
                            <div className="order-header-labels">
                                {!excludeShipmentNumber && (
                                    <label className="label label-default">
                                        <FormattedMessage id="shipmentNumber" defaultMessage="Ref" />
                                        {`: ${thisShipment.attributes.number}`}
                                    </label>
                                )}
                                {thisShipment.selected_shipping_rate && (
                                    // eslint-disable-next-line max-len
                                    <label
                                        style={
                                            excludeShipmentNumber && {
                                                fontSize: '13px',
                                                padding: '0',
                                                color: 'inherit',
                                                whiteSpace: 'break-spaces',
                                                textAlign: 'left',
                                            }
                                        }
                                        className="label label-normal shipping-method"
                                    >
                                        {details && (
                                            <span>{details} - </span>
                                        )}
                                        <FormattedMessage id="shippingMethod" defaultMessage="Shipping Method" />
                                        <span>{`: ${thisShipment.selected_shipping_rate.attributes.name}`}</span>
                                    </label>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12">{store && <div className="shipment-line-items order-line-items">{this._shipmentLineItemsMarkup(store.id, thisShipment)}</div>}</div>
                </div>
            </div>
        );
    }
}

export default Shipment;



/** WEBPACK FOOTER **
 ** ./src/components/order/shipment.jsx
 **/